import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_431: DocMigration = {
  maxSchemaVersion: "0.0.431",
  description: "Type Disriminate Underlays",
  apply(json: any) {
    for (const underlayId in json.underlays) {
      const underlay = json.underlays[underlayId];
      underlay.underlayType = "INLINE_IMAGE";
      underlay.url = underlay.src; // renamed to conform to the same interface as Detail
    }

    return json;
  },
};

export default migration_0_0_431;
